<form [formGroup]="contractFormGroup" class="category-content">
    <div class="data-container light-border">
        <span class="data-title"> Type de contrat * </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="contractType"
                        [matAutocomplete]="autoContractType"
                />
                <mat-error class="error" *ngIf="contractFormGroup.get('contractType')?.hasError('required')">
                    Veuillez choisir un type de contrat
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoContractType="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let contractType of filteredContractTypeList | async"
                            class="tv-ns-select-option"
                            [value]="contractType">
                        {{ contractType.name }} ({{ contractType.id }})
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <div class="data-container light-border">
        <span class="data-title"> Gestionnaire ADV </span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="salesServiceManager"
                        [matAutocomplete]="autoSalesServiceManager"
                />
                <mat-error class="error" *ngIf="contractFormGroup.get('salesServiceManager')?.hasError('required')">
                    Veuillez choisir un gestionnaire ADV
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoSalesServiceManager="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let salesServiceManager of filteredSalesServiceManagerList | async"
                            class="tv-ns-select-option"
                            [value]="salesServiceManager">
                        {{ salesServiceManager.name }} ({{ salesServiceManager.id }})
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>

    <!-- TODO : en attente que UT redemande accès -->
    <!--        <div class="data-container light-border">-->
    <!--            <span class="data-title"> Gestionnaire facturation </span>-->
    <!--            <div class="tv-rect-input-small-no-label full-width">-->
    <!--                <mat-form-field>-->
    <!--                    <input-->
    <!--                            matInput-->
    <!--                            formControlName="billingManager"-->
    <!--                            [matAutocomplete]="autoBillingManager"-->
    <!--                    />-->
    <!--                    <mat-error class="error" *ngIf="contractFormGroup.get('billingManager')?.hasError('required')">-->
    <!--                        Veuillez choisir un gestionnaire de facturation-->
    <!--                    </mat-error>-->
    <!--                    <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"-->
    <!--                                      #autoBillingManager="matAutocomplete"-->
    <!--                                      [displayWith]="displayAutoCompleteData">-->
    <!--                        <mat-option-->
    <!--                                *ngFor="let billingManager of filteredBillingManagerList | async"-->
    <!--                                class="tv-ns-select-option"-->
    <!--                                [value]="billingManager">-->
    <!--                            {{ billingManager.name }} ({{ billingManager.id }})-->
    <!--                        </mat-option>-->
    <!--                    </mat-autocomplete>-->
    <!--                </mat-form-field>-->
    <!--            </div>-->
    <!--        </div>-->

    <div class="data-container light-border">
        <span class="data-title"> Envoyé le *</span>
        <div class="full-width">
            <custom-date-picker
                    [formControl]="sentOnDateControl"
                    [styleType]="'squared-small'"
                    valueFormat="dd/MM/yyyy"
                    [required]="true"
                    (chosenDate)="onSentOnDateChosen()">
            </custom-date-picker>
        </div>
    </div>

    <div class="data-container light-border">
        <span class="data-title"> Date retour client *</span>
        <div class="full-width">
            <custom-date-picker
                    [formControl]="customerReturnDateControl"
                    [styleType]="'squared-small'"
                    valueFormat="dd/MM/yyyy"
                    [required]="true"
                    (chosenDate)="onCustomerReturnDateChosen()">
            </custom-date-picker>
        </div>
    </div>

    <div class="data-container light-border">
        <span class="data-title"> Etat *</span>
        <div class="tv-rect-input-small-no-label full-width">
            <mat-form-field>
                <input
                        matInput
                        formControlName="contractState"
                        [matAutocomplete]="autoContractState"
                />
                <mat-error class="error" *ngIf="contractFormGroup.get('contractState')?.hasError('required')">
                    Veuillez choisir un état
                </mat-error>
                <mat-autocomplete autoActiveFirstOption class="tv-custom-always-visible-scroll-bar"
                                  #autoContractState="matAutocomplete"
                                  [displayWith]="displayAutoCompleteData">
                    <mat-option
                            *ngFor="let contractState of filteredContractStateList | async"
                            class="tv-ns-select-option"
                            [value]="contractState">
                        {{ contractState.name }} ({{ contractState.id }})
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
</form>
